import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText, LabelText } from '@calendly/ui/components/typography'
import { ViewSwitcher } from '@calendly/ui/components/view-switcher'

import { Layout } from 'components/layout'

const DistributionMethodLayout = ({ optionName, children }) => (
  <Layout gap="4" direction="column" align="start">
    <LabelText
      id="distribution-label"
      size="large"
    >
      {I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.distribution_label')}
    </LabelText>
    {children}
    <BodyText>
      {optionName === 'availability'
        ? I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.helper_text_availability')
        : I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.helper_text_fairness')}
    </BodyText>
  </Layout>
)

const getSelectOptions = () => [
  {
    value: 'availability',
    text: I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.distribution_options.availability')
  },
  {
    value: 'fairness',
    text: I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.distribution_options.fairness_v4')
  }
]

const DistributionMethodField = ({ userPool, disabled }) => {
  const name = userPool
    ? `userPools.${userPool.position}.allocation_preference`
    : 'allocationPreference'

  const [fieldProps] = useFormField({ name })
  const { value } = fieldProps

  const options = getSelectOptions()

  return (
    <DistributionMethodLayout optionName={value}>
      <ViewSwitcher
        name="distribution-method"
        {...fieldProps}
        options={options}
        disabled={disabled}
      />
    </DistributionMethodLayout>
  )
}

const DistributionMethodLocked = ({ userPool }) => {
  const name = userPool
    ? `userPools.${userPool.position}.allocation_preference`
    : 'allocationPreference'

  const [{ value }] = useFormField({ name })

  const optionName = getSelectOptions().find((option) => option.value === value)?.text

  if (!optionName) return null

  return (
    <DistributionMethodLayout optionName={optionName}>
      <BodyText>{optionName}</BodyText>
    </DistributionMethodLayout>
  )
}

export const DistributionMethod = ({ isLocked, ...props }) => (
  !isLocked ? <DistributionMethodField {...props} /> : <DistributionMethodLocked {...props} />
)
